import { useEffect, useRef, useState } from "react";
import { framingStyle } from "../../utilities/framing";

// Fills the nearest positioned ancestor with a cover-cropped image framed
// by a focal point + zoom (pure geometry, no transform — see framingStyle).
// Hover scale lives on a wrapper so it magnifies the framed result.
//
// When thumbSrc is given it's rendered instead of src, falling back to
// src once if the thumb 404s (legacy items whose thumbnail hasn't been
// backfilled).
export default function FramedImage({
  src,
  thumbSrc,
  alt = "",
  framing,
  hoverZoom = false,
  className = "",
  loading,
  onLoad,
}) {
  const [thumbFailed, setThumbFailed] = useState(false);
  const imgRef = useRef(null);
  const activeSrc = thumbSrc && !thumbFailed ? thumbSrc : src;

  // Catch a thumb that broke before React attached the error handler
  // (e.g. cached failure) — onError alone misses that case.
  useEffect(() => {
    const img = imgRef.current;
    if (!thumbSrc || thumbFailed || !img) return;
    if (img.complete && img.naturalWidth === 0) setThumbFailed(true);
  }, [thumbSrc, thumbFailed]);

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      <div
        className={`w-full h-full ${
          hoverZoom
            ? "group-hover:scale-[1.03] transition-transform duration-300"
            : ""
        }`}
      >
        <img
          ref={imgRef}
          src={activeSrc}
          alt={alt}
          loading={loading}
          onLoad={onLoad}
          onError={() => {
            if (thumbSrc && !thumbFailed) setThumbFailed(true);
          }}
          draggable={false}
          style={framingStyle(framing)}
        />
      </div>
    </div>
  );
}
